import { render, staticRenderFns } from "./addParkingArea.vue?vue&type=template&id=8ddd8a84"
import script from "./addParkingArea.vue?vue&type=script&lang=js"
export * from "./addParkingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports